// Без импортов: подключается из router.js
export const BILLING_API_URL = process.env.VUE_APP_BILLING_API_URL
export const BILLING_PRODUCT = process.env.VUE_APP_BILLING_PRODUCT || 'profit'
export const billingEnabled = !!BILLING_API_URL
